import { type FunctionComponent, useCallback } from 'react';
import cx from 'classnames';

import { Analytics } from '@trello/atlassian-analytics';
import { getTestId } from '@trello/test-ids';

import { useCanEditBoard } from 'app/src/components/BoardPermissionsContext';
import { openCardComposer } from 'app/src/components/CardComposer';

import styles from './ListCardGap.less';

interface ListCardGapProps {
  position: number;
  listId: string;
  className?: string;
}

export const ListCardGap: FunctionComponent<ListCardGapProps> = ({
  position,
  listId,
  className,
}) => {
  const canEditBoard = useCanEditBoard();

  const onClick = useCallback(() => {
    Analytics.sendUIEvent({
      action: 'opened',
      actionSubject: 'cardComposer',
      source: 'boardScreen',
      attributes: {
        method: 'listCardGap',
      },
    });

    openCardComposer({ position, listId });
  }, [listId, position]);

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={cx(styles.listCardGap, className, {
        [styles.disabled]: !canEditBoard,
      })}
      onClick={onClick}
      data-testid={getTestId('list-card-gap')}
    >
      <div className={styles.hoverBar} />
      <div className={styles.hoverIcon} />
      <div className={styles.hoverBar} />
    </div>
  );
};
